import { getCookie } from "app/utils/cookie";
import { UtmObjectModel } from "app/models";

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
] as const;

export const getUTMParams = (): UtmObjectModel => {
  const utmParams: UtmObjectModel = {};

  UTM_KEYS.forEach((key) => {
    const value = getCookie(key);
    if (value) {
      utmParams[key] = value;
    }
  });

  return utmParams;
};
